<template>
  <div>
    <v-chip
      v-for="item in items"
      :key="item.id"
      :color="item.color"
      :class="chipClass"
    >
      <span :style="{ color: determineTextColor(item.color) }">
        <slot :item="item" />
      </span>
    </v-chip>
  </div>
</template>

<script>
import { getContrastColor, hexToRgb } from '@/components/colorContrast';

const DEFAULT_TEXT_COLOR = '#000';

export default {
  name: 'ColorLegend',
  props: {
    items: {
      type: Array,
      required: true,
    },
    chipClass: {
      type: [String, Array],
      default: () => [],
    },
  },
  methods: {
    determineTextColor(color) {
      if (!color) {
        return DEFAULT_TEXT_COLOR;
      }

      const rgb = hexToRgb(color);
      return getContrastColor(rgb);
    },
  },
};
</script>
